import { render, staticRenderFns } from "./AreasForAttachingImages.vue?vue&type=template&id=06c74418&scoped=true&"
import script from "./AreasForAttachingImages.vue?vue&type=script&lang=ts&"
export * from "./AreasForAttachingImages.vue?vue&type=script&lang=ts&"
import style0 from "./AreasForAttachingImages.vue?vue&type=style&index=0&id=06c74418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c74418",
  null
  
)

export default component.exports